<template>
  <div>
    <!------------------
            HEADER
    -------------------->
    <div class="bg-white p-3 pl-4 page-header" ref="pageHeader" style="padding-bottom: 0">
      <div class="row d-flex align-items-top">
        <div class="col">
          <div>
            <h4>
              <b-icon class="me-2" icon="gem"></b-icon>
              Preiserfassung
            </h4>
          </div>
        </div>
        <div class="col-auto">
          <div class="form-inline">
            <!---------------------------------
            HEADER ACTION BUTTONS
        ---------------------------------->

            <!-- SEARCH FIELD  -->
            <b-input-group class="ml-2 header-search-field">
              <b-form-input
                type="search"
                size="sm"
                v-model.lazy="searchText"
                :class="{ 'bg-primary-light-3': searchText !== '' }"
              ></b-form-input>
              <template #prepend>
                <b-input-group-text>
                  <b-icon variant="dark" icon="search" />
                </b-input-group-text>
              </template>
            </b-input-group>
            <!-- FILTER BUTTON  -->
            <b-button
              size="sm"
              :variant="filterToggle == true ? 'primary' : 'light'"
              class="ml-2"
              :pressed="filterToggle"
              :disabled="!checkedSomeTableEntries"
              @click="filterRecords"
            >
              <b-icon icon="funnel"></b-icon>
            </b-button>
            <!-- HELP ICON  -->
            <b-button
              size="sm"
              variant="light"
              class="ml-2"
              href="https://www.bauvisor.de/preiserfassung/"
              target="_blank"
            >
              <b-icon icon="question-circle" variant="dark" class=""></b-icon>
            </b-button>
            <b-dropdown
              size="sm"
              variant="light"
              toggle-class="text-decoration-none"
              no-caret
              right
              class="ml-2 mr-2"
              v-if="$root.$user.isPlaner || $root.$user.isAdmin"
            >
              <template #button-content>
                <b-icon icon="three-dots-vertical" variant="dark" class="mr-1"></b-icon>
              </template>
              <b-dropdown-item href="#" @click="onDeleteLVPreiseClick" :disabled="!checkedSomeTableEntries">
                <b-icon icon="trash" class="mr-1" />
                LV-Preise löschen
              </b-dropdown-item>
              <b-dropdown-item href="#" @click="onDeleteAngeboteClick" :disabled="!checkedSomeTableEntries">
                <b-icon icon="trash" class="mr-1" />
                Angebote löschen
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
      </div>
    </div>
    <div class="main-canvas">
      <div class="table-wrapper table-fill pe-table shadow-muted-super mt-3" :style="{ height: tableHeight }">
        <b-table
          small
          v-resizable-columns="{ fields: visibleFields, storageKey: 'preiserfassung', flexLast: false }"
          :items="items"
          :fields="visibleFields"
          class="bg-white shadow-muted-super sum-header mb-0"
          no-border-collapse
          head-variant="light"
          @row-clicked="onTableRowClicked"
          :busy="tableIsBusy"
          :sticky-header="tableHeight"
          show-empty
          :filter="searchText"
          @filtered="onHandleFilterChange"
          ref="theTable"
        >
          <template #empty>
            <div class="block text-center text-muted p-5">Keine Vergabeeinheiten vorhanden.</div>
          </template>
          <template #head(checked)>
            <b-form-checkbox
              class="ml-2"
              :disabled="items.length == 0"
              v-model="checkedAllTableEntries"
              @change="onCheckAllTableEntries"
            ></b-form-checkbox>
          </template>
          <template #head(ActiveQuoteAmount)>
            Angebots&shy;preis
            <!-- Angebotspreis, falls genug Platz. Angebots-<br>preis falls zu eng 
          Angebots-&#8203;Preis
          unsichbarer Whitespace, somit lediglich Sollumbruchstelle. Angebots-Preis falls genug Platz, Angebots-<br>Preis falls zu eng -->
          </template>
          <template #head(BudgetTotal)>
            Budget /
            <br />
            Zielvorgabe
          </template>

          <template #cell(checked)="data">
            <b-form-checkbox
              class="ml-2"
              @change="onCheckedItemChange(data.item)"
              v-model="data.item.checked"
            ></b-form-checkbox>
          </template>
          <template #cell(LVPreis)="data">
            <div
              class="field-lvpreis action-button"
              v-if="$root.$user.isPlaner || $root.$user.isAdmin"
              @click="onTableRowClicked(data.item, data.index, $event)"
            >
              {{ formatCurrency(data.item.LVPreis) }}
            </div>
            <div class="field-lvpreis" @click.stop v-if="!($root.$user.isPlaner || $root.$user.isAdmin)">
              {{ formatCurrency(data.item.LVPreis) }}
            </div>
          </template>
          <template #cell(LVBudgetabweichung)="data">
            <table
              class="table table-borderless table-no-hover w-100 m-0"
              :class="{ 'action-button': $root.$user.isPlaner || $root.$user.isAdmin }"
              @click="onLVAbweichungCellClick(data.item)"
            >
              <tr>
                <td
                  class="text-right text-muted text-nowrap"
                  style="padding-top: 5px; padding-bottom: 0px; padding-right: 0"
                >
                  <span class="text-nowrap" v-if="data.item.LVPreis != null && parseFloat(data.item.LVPreis) != 0">
                    {{ formatCurrency(calcLVAbweichung(data.item)) }}
                  </span>
                </td>
                <td rowspan="2" class="py-0 px-0 align-middle text-center" style="width: 40px">
                  <b-icon
                    icon="aa"
                    class="rounded-circle"
                    :class="{
                      'bg-primary-semi-light': data.item.LVPreis == null || parseFloat(data.item.LVPreis) == 0,
                      'bg-success':
                        data.item.LVPreis <= calcZielVergabe(data.item) &&
                        data.item.LVPreis != null &&
                        parseFloat(data.item.LVPreis) != 0,
                      'bg-danger': data.item.LVPreis > data.item.BudgetTotal,
                      'bg-warning':
                        data.item.LVPreis <= data.item.BudgetTotal && data.item.LVPreis > calcZielVergabe(data.item)
                    }"
                    style="padding: 10px; margin-top: 5px"
                    variant="light"
                  ></b-icon>
                </td>
              </tr>
              <tr>
                <td class="text-right text-muted" style="padding-top: 0px; padding-bottom: 2px; padding-right: 0">
                  <span class="text-nowrap" v-if="data.item.LVPreis != null && parseFloat(data.item.LVPreis) != 0">
                    {{ formatCurrency(calcZVAbweichung(data.item)) }}
                  </span>
                </td>
              </tr>
            </table>
          </template>
          <template #cell(BudgetTotal)="data">
            {{ formatCurrency(data.item.BudgetTotal) }}
            <br />
            {{ formatCurrency(calcZielVergabe(data.item)) }}
          </template>
          <template #cell(ABudgetabweichung)="data">
            <table
              class="table table-borderless w-100 m-0 action-button"
              @click="onBudgetAbweichungCellClick(data.item)"
            >
              <tr>
                <td
                  class="text-right text-muted text-nowrap"
                  style="padding-top: 5px; padding-bottom: 0px; padding-right: 0"
                >
                  <span v-if="data.item.ActiveQuoteAmount != null && parseFloat(data.item.ActiveQuoteAmount) != 0">
                    {{ formatCurrency((data.item.BudgetTotal - data.item.ActiveQuoteAmount) * -1) }}
                  </span>
                </td>
                <td rowspan="2" class="py-0 px-0 align-middle text-center" style="width: 40px">
                  <b-icon
                    icon="aa"
                    class="rounded-circle"
                    :class="{
                      'bg-primary-light':
                        data.item.ActiveQuoteAmount == null || parseFloat(data.item.ActiveQuoteAmount) == 0,
                      'bg-success':
                        data.item.ActiveQuoteAmount <= calcZielVergabe(data.item) &&
                        data.item.ActiveQuoteAmount != null &&
                        parseFloat(data.item.ActiveQuoteAmount) != 0,
                      'bg-danger': data.item.ActiveQuoteAmount > data.item.BudgetTotal,
                      'bg-warning':
                        data.item.ActiveQuoteAmount <= data.item.BudgetTotal &&
                        data.item.ActiveQuoteAmount > calcZielVergabe(data.item)
                    }"
                    style="padding: 10px; margin-top: 5px"
                    variant="light"
                  ></b-icon>
                </td>
              </tr>
              <tr>
                <td
                  class="text-right text-muted text-nowrap"
                  style="padding-top: 0px; padding-bottom: 2px; padding-right: 0"
                >
                  <span v-if="data.item.ActiveQuoteAmount != null && parseFloat(data.item.ActiveQuoteAmount) != 0">
                    {{ formatCurrency((calcZielVergabe(data.item) - data.item.ActiveQuoteAmount) * -1) }}
                  </span>
                </td>
              </tr>
            </table>

            <!--
          <div class="text-right pr-2">
            {{ data.item.ABudgetabweichung }}
            <b-icon
              icon="aa"
              class="float-right rounded-circle bg-warning ml-2"
              style="padding:10px"
              variant="light"
            ></b-icon>
          </div>
          <div class="text-right pr-2">
            {{ data.item.ABudgetabweichung }}
            <b-icon
              icon="aa"
              class="float-right rounded-circle bg-warning ml-2"
              style="padding:10px"
              variant="light"
            ></b-icon>
          </div>
          --></template>
        </b-table>
        <TableFooter
          :displayed-count="displayedItemsCount"
          :selected-count="selectedRows.length"
          :loading="tableIsBusy"
        />
      </div>
    </div>
    <EditLVPreis @ok="onAllocationUnitUpdated" :allocationUnit="clickedAllocationUnit" />
    <EditQuote @ok="onAllocationUnitUpdated" :allocationUnit="clickedAllocationUnit" />
  </div>
</template>

<script>
import AppState from '@/store/App.js';
import settingsStore from '@/store/Settings';
import projectStore from '@/store/Projects';
import allocationUnitsService from '@/service/AllocationUnitsService';
import EditLVPreisComponent from '@/components/vergabeeinheiten/EditLVPreis';
import EditQuoteComponent from '@/components/vergabeeinheiten/EditQuote';
import TableFooter from '@/components/TableFooter';
export default {
  components: {
    EditLVPreis: EditLVPreisComponent,
    EditQuote: EditQuoteComponent,
    TableFooter
  },
  created() {
    this.$eventBus.$on('projectSwitched', () => {
      this.searchText = '';
    });
  },
  activated() {
    AppState.isLoading = false;
    this.loadAllocationUnits();
    if (this.settingsStore.settings['KGR_Selections_Active'] == 'false') {
      this.fields.find(x => x.key == 'KGR').visible = false;
    } else {
      this.fields.find(x => x.key == 'KGR').visible = true;
    }
    if (this.settingsStore.settings['Responsible_Selections_Active'] == 'false') {
      this.fields.find(x => x.key == 'Responsible').visible = false;
    } else {
      this.fields.find(x => x.key == 'Responsible').visible = true;
    }
    if (this.settingsStore.settings['FA1_Active'] == 'false') {
      this.fields.find(x => x.key == 'FA1').visible = false;
    } else {
      this.fields.find(x => x.key == 'FA1').visible = true;
    }
    if (this.settingsStore.settings['FA2_Active'] == 'false') {
      this.fields.find(x => x.key == 'FA2').visible = false;
    } else {
      this.fields.find(x => x.key == 'FA2').visible = true;
    }
    window.addEventListener('resize', this.onWindowResize); // listen for windows size changes, to re-compute height of controls
    this.onWindowResize();
  },
  deactivated() {
    window.removeEventListener('resize', this.onWindowResize);
  },
  data() {
    return {
      settingsStore,
      filterToggle: false,
      items: [],
      selectedRows: [],
      displayedItemsCount: 0,
      fields: [
        {
          key: 'checked',
          label: '',
          //thClass: 'align-top text-center compact',
          //tdClass: 'align-middle text-center compact',
          tdClass: 'sticky-col first-col text-center align-middle',
          thClass: 'sticky-col first-col text-center align-top noselect',
          thStyle: 'z-index:10;width: 40px;',
          visible: true
        },
        {
          key: 'Ordinal',
          label: 'VE',
          thClass: 'align-top sticky-col second-col',
          tdClass: 'sticky-col second-col align-middle',
          thStyle: 'z-index:10;width: 140px;',
          visible: true,
          sortable: true
        },
        {
          key: 'DisplayName',
          label: 'Bezeichnung',
          thClass: 'align-top sticky-col third-col',
          tdClass: 'sticky-col third-col align-middle',
          thStyle: 'z-index:10;width: 300px;',
          visible: true,
          sortable: true
        },

        {
          visible: true,
          key: 'KGR',
          label: 'Kostengruppe',
          thClass: 'align-top noselect',
          tdClass: 'align-middle',
          tdStyle: 'padding-left: 5px; padding-right: 5px;',

          sortable: true
        },
        {
          visible: true,
          key: 'Responsible',
          label: 'Verantwortlich',
          thClass: 'align-top noselect',
          tdClass: 'align-middle p-1',
          sortable: true
        },
        {
          visible: true,
          key: 'FA1',
          label: settingsStore.settings['FA1'],
          thClass: 'align-top noselect ',
          tdClass: 'align-middle p-1 ',
          sortable: true
        },
        {
          visible: true,
          key: 'FA2',
          label: settingsStore.settings['FA2'],
          thClass: 'align-top noselect',
          tdClass: 'align-middle p-1',
          sortable: true
        },
        {
          key: 'ProcessStatus',
          label: 'Status',
          thClass: 'align-top',
          tdClass: 'align-middle ',
          visible: true,
          sortable: true
        },
        {
          key: 'BudgetTotal',
          label: 'Budget',
          tdClass: 'align-middle text-right action-button field-budget',
          thClass: 'align-top text-right',
          thStyle: 'min-width:160px',
          visible: true,
          sortable: true
        },
        {
          key: 'LVPreis',
          label: 'LV-Preis',
          tdClass: 'align-middle text-right text-nowrap bg-primary-light field-lvpreis',
          thClass: 'align-top text-right',
          thStyle: 'min-width:160px',
          visible: true,
          formatter: x => this.formatCurrency(x),
          sortable: true
        },
        {
          key: 'LVBudgetabweichung',
          label: 'Abweichung',
          tdClass: 'align-middle p-0 bg-primary-light',
          thClass: 'align-top text-right',
          tdStyle: 'min-width:160px;',
          thStyle: 'min-width:160px;',
          visible: true,
          sortable: true
        },
        {
          key: 'ActiveQuoteAmount',
          label: 'Angebots-preis',
          tdClass: 'align-middle text-right bg-primary-semi-light action-button field-apreis',
          thClass: 'align-top text-right',
          thStyle: 'min-width:160px',
          visible: true,
          formatter: x => this.formatCurrency(x),
          sortable: true
        },
        {
          key: 'ABudgetabweichung',
          label: 'Abweichung',
          tdClass: 'align-middle p-0 bg-primary-semi-light',
          thClass: 'align-top text-right',
          thStyle: 'min-width:160px',
          visible: true,
          sortable: true
        }
      ],
      checkedAllTableEntries: false,
      checkedSomeTableEntries: false,
      tableIsBusy: false,
      clickedAllocationUnit: {
        LVPreis: null
      },
      tableHeight: '500px',
      searchText: ''
    };
  },
  methods: {
    loadAllocationUnits() {
      this.tableIsBusy = true;
      allocationUnitsService
        .getAllocationUnitsWithQuotes(projectStore.activeProject.DbId)
        .then(items => {
          var allChecked = items.length > 0;
          this.items = items.map(x => {
            x.editMode = false;
            x.checked = this.selectedRows.find(y => y.DbId == x.DbId) != null;
            if (x.checked !== true) allChecked = false;
            x.BudgetTotal = parseFloat(x.BudgetTotal);
            x.LVBudgetabweichung = (parseFloat(x.BudgetTotal) - parseFloat(x.LVPreis)) * -1;
            x.ABudgetabweichung = (parseFloat(x.BudgetTotal) - parseFloat(x.ActiveQuoteAmount)) * -1;

            if (isNaN(x.LVBudgetabweichung)) x.LVBudgetabweichung = 0;
            if (isNaN(x.ABudgetabweichung)) x.ABudgetabweichung = 0;

            if (x.StatusText == 'offen') {
              if (x.ProcessStatus) {
                x.StatusText = x.ProcessStatus;
              }
            }

            return x;
          });
          if (this.filterToggle) {
            allChecked = true;
            this.itemsBackup = [...this.items];
            this.items = this.items.filter(x => {
              return x.checked == true;
            });
          }
          this.checkedAllTableEntries = allChecked;
        })
        .catch(error => this.$showError(this, error.toString()))
        .finally(() => {
          this.tableIsBusy = false;
          if (AppState.scrollPosition[this.$route.path])
            this.$refs.theTable.$el.scrollTo({
              top: AppState.scrollPosition[this.$route.path][0],
              left: AppState.scrollPosition[this.$route.path][1]
            });
          this.displayedItemsCount = this.items.length;
        });
    },

    formatCurrency(number) {
      if (!number) return '-';
      return this.$utils.numberToCurrency(number, settingsStore.settings['Centbetraege']);
    },

    calcZielVergabe(item) {
      // Zielvergabe = BudgetTotal - Nachtragsrückstellung
      var ntr = 0;
      if (!item.NTR) {
        ntr = parseFloat(this.settingsStore.settings['Nachtragsprozent']).toFixed(2);
      } else {
        ntr = parseFloat(item.NTR);
      }
      return parseFloat(item.BudgetTotal) * (1 - parseFloat(ntr / 100));
    },
    calcLVAbweichung(item) {
      return (parseFloat(item.BudgetTotal) - parseFloat(item.LVPreis)) * -1;
    },
    calcZVAbweichung(item) {
      return (this.calcZielVergabe(item) - item.LVPreis) * -1;
    },
    onHandleFilterChange(visibleItems) {
      this.displayedItemsCount = visibleItems.length;
      // remove check from all non-visible rows
      const checkItems = this.items.filter(x => x.checked == true);
      checkItems.forEach(item => {
        if (visibleItems.findIndex(x => x.DbId == item.DbId) == -1) {
          item.checked = false;
          // also remove from selected rows
          const index = this.selectedRows.findIndex(x => x.DbId == item.DbId);
          if (index != -1) {
            this.selectedRows.splice(index, 1);
          }
        }
      });
      // are all visible rows checked, then also check the "check all" checkbox
      let allChecked = true;
      visibleItems.forEach(item => {
        if (item.checked != true) allChecked = false;
      });
      this.checkedAllTableEntries = visibleItems.length > 0 && allChecked;
    },
    onTableRowClicked(item, idx, evt) {
      this.clickedAllocationUnit = item;
      if (evt.target.classList.contains('field-apreis')) {
        //if (!(this.$root.$user.isPlaner || this.$root.$user.isAdmin)) return;
        this.$nextTick(() => {
          this.$bvModal.show('editQuoteModal');
        });
      } else if (evt.target.classList.contains('field-lvpreis')) {
        if (!(this.$root.$user.isPlaner || this.$root.$user.isAdmin)) return;
        this.$nextTick(() => {
          this.$bvModal.show('editLVPreisModal');
        });
      } else if (evt.target.classList.contains('field-budget')) {
        this.$router.push(`/allocationunits/${item.DbId}`);
      }
    },
    onAllocationUnitUpdated(updatedAllocationUnit) {
      allocationUnitsService
        .updateAllocationUnit(updatedAllocationUnit)
        .then(() =>
          this.$showSuccess(this, 'Vergabeeinheit aktualisieren', 'Vergabeeinheit erfolgreich aktualisiert. ')
        )
        .catch(err => {
          if (err.response) this.$showError(this, err.response.data.error);
          else this.$showError(this, err.toString());
        })
        .finally(() => {
          this.loadAllocationUnits();
        });
    },
    onWindowResize() {
      const totalHeight = window.innerHeight;
      const headerHeight = this.$refs.pageHeader.offsetHeight;
      const tableHeight = totalHeight - headerHeight - 60;
      this.tableHeight = tableHeight + 'px';
    },
    onDeleteLVPreiseClick() {},
    onDeleteAngeboteClick() {},
    onCheckAllTableEntries() {
      this.checkedSomeTableEntries = this.checkedAllTableEntries;
      this.items.map(x => {
        return (x.checked = this.checkedAllTableEntries);
      });
      this.selectedRows = this.items.filter(x => x.checked == true);
    },
    onCheckedItemChange(item) {
      this.checkedSomeTableEntries = false;
      this.selectedRows = this.items.filter(x => x.checked == true);
      for (let i = 0; i < this.items.length; i++) {
        if (this.items[i].checked) {
          this.checkedSomeTableEntries = true;
          break;
        }
      }
      if (!item.checked) {
        return (this.checkedAllTableEntries = false);
      }

      for (let i = 0; i < this.items.length; i++) {
        if (!this.items[i].checked) {
          return (this.checkedAllTableEntries = false);
        }
      }

      this.checkedAllTableEntries = true;
    },
    onLVAbweichungCellClick(item) {
      if (!(this.$root.$user.isPlaner || this.$root.$user.isAdmin)) return;
      this.clickedAllocationUnit = item;
      this.$nextTick(() => {
        this.$bvModal.show('editLVPreisModal');
      });
    },
    onBudgetAbweichungCellClick(item) {
      this.clickedAllocationUnit = item;
      this.$nextTick(() => {
        this.$bvModal.show('editQuoteModal');
      });
    },
    filterRecords() {
      if (!this.filterToggle) {
        this.filterToggle = true;
        this.itemsBackup = [...this.items];
        this.items = this.items.filter(x => {
          return x.checked == true;
        });
        this.checkedAllTableEntries = true;
      } else {
        this.filterToggle = false;
        this.items = this.itemsBackup;
        this.checkedAllTableEntries = this.selectedRows.length == this.items.length;
      }
    }
  },
  computed: {
    visibleFields() {
      return this.fields.filter(field => field.visible);
    }
  },
  beforeRouteLeave(to, from, next) {
    AppState.scrollPosition[from.path] = [this.$refs.theTable.$el.scrollTop, this.$refs.theTable.$el.scrollLeft];
    next();
  }
};
</script>

<style>
/*
tbody tr:hover {
  color: inherit !important;
  background-color: inherit !important;
}*/
.table-wrapper {
  border: 1px solid #dee2e6;
}

.table-wrapper tbody tr td.sticky-col {
  background-color: var(--bauvisor-primary-light) !important;
}

.table-wrapper td:not(:last-child) {
  border-right: 1px solid #dee2e6;
}

.table-wrapper tr:last-child td {
  border-bottom: 1px solid #ced2d6;
}

.table-borderless * {
  border: none !important;
}

.first-col {
  left: 0;
}

.second-col {
  left: 40px;
}

.third-col {
  left: 180px;
  text-overflow: ellipsis;
  overflow: hidden;
}
/* Clip overflowing header/cell content with an ellipsis when a column is
   narrowed by dragging. Applied to the cell itself (covers plain-text columns
   like Kostengruppe that have no wrapper element) and to a direct child <div>
   (covers slots that wrap their content). Scoped with `.pe-table` so it also
   wins over rules leaking in from other table views. */
.pe-table.table-wrapper th:not(.sticky-col),
.pe-table.table-wrapper td:not(.sticky-col),
.pe-table.table-wrapper th:not(.sticky-col) > div,
.pe-table.table-wrapper td:not(.sticky-col) > div {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* The Abweichung cells embed a full-width nested table holding the coloured
   circle; keep its inner cells unclipped so the circle keeps its position. */
.pe-table.table-wrapper .table-borderless td {
  overflow: visible;
  text-overflow: clip;
}

/* Other table views (e.g. Orders.vue) ship NON-scoped global `.table-wrapper`
   rules that stay injected in <head> and bleed into this page after in-app
   navigation, breaking column widths and the circle cells (Orders' rule
   `.table-wrapper td:not(.sticky-col){max-width:0}` collapses the 40px circle
   cells). These higher-specificity overrides (via the extra `.pe-table` class)
   neutralize that leak so this table always renders as on a fresh reload. */
.pe-table.table-wrapper th:not(.sticky-col),
.pe-table.table-wrapper td:not(.sticky-col) {
  max-width: none;
}

.pe-table.table-wrapper tbody tr td.sticky-col {
  background-color: var(--bauvisor-primary-light) !important;
}
</style>
